module.exports = __webpack_public_path__ + "media/images/companyPage/growth-d45449cf5107d0a2ff18e1307be599e3.svg";